import type { PageHelp } from '../network-help.data';

export const L10N_ar_g4: Record<string, PageHelp> = {
  'trains-ticket': {
    title: 'تذكرة القطار',
    tag: 'التذكرة الإلكترونية الصادرة',
    tagline: 'التذكرة الإلكترونية الصادرة للسكك الحديدية — رقم الحجز، العربة / المقعد، رمز QR وربح عملية البيع.',
    business: {
      lead: 'هذا هو إثبات بيع السكك الحديدية — رقم الحجز ورمز QR / الباركود الذي يمسحه المسافر للصعود، بالإضافة إلى العربة والمقعد المؤكدين. كما يُغلق الدائرة التجارية، إذ يُظهر للوكيل الهامش المحقق على الحجز.',
      points: [
        { title: 'الصعود باستخدام رمز QR', desc: 'الرقم المرجعي والباركود هما ما يقدّمه المسافر للصعود.' },
        { title: 'العربة والمقعد مؤكدان', desc: 'العربة والمقعد المحددان (واتجاهه / حالته) موجودان على التذكرة.' },
        { title: 'تحقّق الربح', desc: 'ملخّص البيانات المالية يُظهر الهامش على عملية البيع هذه بوضوح.' },
      ],
    },
    software: {
      lead: 'تذكرة تتضمن الرحلة والعربة / المقعد والبيانات المالية.',
      points: [
        { title: 'الترويسة وشريط المسافر', desc: 'رقم الحجز، اسم المسافر، رقم التذكرة، الدرجة وتاريخ الإصدار.' },
        { title: 'الرحلة والمقعد', desc: 'المُشغّل، رقم الخدمة، محطتا المغادرة / الوصول والمدة، بالإضافة إلى صف العربة / المقعد والباركود.' },
        { title: 'البيانات المالية والإجراءات', desc: 'شريط جانبي للهامش بالإضافة إلى أدوات البريد الإلكتروني / النسخ / التعديل / الاسترداد.' },
      ],
    },
    related: ['trains-payment', 'bookings', 'booking-detail', 'refunds'],
  },

  'hotels-results': {
    title: 'نتائج الفنادق',
    tag: 'البحث عن الفنادق',
    tagline: 'العقارات المتاحة للإقامة، مرتّبة — مع ظهور نمط البيع وسياسة الاسترداد قبل أن تلتزم.',
    business: {
      lead: 'تُظهر شاشة النتائج كل عقار قابل للحجز للبحث المطلوب، وتمزج المخزون المتعاقد عليه ذاتياً مع العرض المتصل. الشارات المهمة تجارياً — الفوري مقابل عند الطلب، القابل للاسترداد مقابل غير القابل — موجودة على البطاقة، لذا يختار الوكيل وهو يعلم كيف سيتأكد الحجز ومتى تتحرك الأموال.',
      points: [
        { title: 'دمج المخزون الذاتي + المتصل', desc: 'يتم ترتيب الغرف من وحدة عقارات الفنادق في المنصة ومن المورّدين الخارجيين في قائمة واحدة.' },
        { title: 'نمط البيع مرئي', desc: 'الفوري يتأكد بالنقر؛ عند الطلب يحتفظ بالحجز حتى يقبله مورّد — الشارة تُخبر الوكيل بأيهما يحصل عليه.' },
        { title: 'سياسة الاسترداد واضحة مسبقاً', desc: 'الإلغاء المجاني مقابل غير القابل للاسترداد هو مرشّح وعلامة، حتى يعرض الوكيل السياسة الصحيحة.' },
      ],
    },
    software: {
      lead: 'قائمة عقارات قابلة للتصفية مع شريط أسعار ودرج لاختيار الغرفة.',
      points: [
        { title: 'تصفية العقارات', desc: 'يضيّق الشريط الجانبي حسب الترتيب، تصنيف النجوم، نطاق السعر، سياسة الاسترداد، المنطقة والمورّد، بالإضافة إلى نص حر على الاسم / المنطقة / السلسلة.' },
        { title: 'استعراض شريط الأسعار', desc: 'تقويم أسعار ليلية لمدة 7 أيام حول تاريخ الوصول؛ انقر على تاريخ لإعادة البحث.' },
        { title: 'اختيار غرفة للحجز', desc: 'تُظهر البطاقات أفضل سعر ليلي مقابل السعر المعلن، درجة التقييم وعلامة الاسترداد؛ «اختيار الغرفة» يفتح درج الحجز.' },
      ],
    },
    flow: {
      lead: 'من صفحة النتائج، يكتمل الحجز في درج (لا في صفحات منفصلة) ينتهي إلى القسيمة.',
      steps: [
        { title: 'اختيار الغرفة والسعر', desc: 'اختر نوع الغرفة وخطة السعر؛ يغطي الإجمالي كل الليالي بالإضافة إلى الضرائب، مع عرض سياسة الاسترداد.' },
        { title: 'بيانات الضيف', desc: 'نموذج واحد لكل ضيف في كل غرفة (اللقب، الاسم، تاريخ الميلاد، الجنسية، جواز السفر)؛ يُملأ العميل المحفوظ مسبقاً من نظام إدارة علاقات العملاء. يحمل الضيف الرئيسي جهة اتصال الحجز.' },
        { title: 'الدفع (+ الإضافات)', desc: 'اختر طريقة الدفع؛ على المخزون الذاتي، يمكن إضافة خدمات اختيارية (موقف سيارات، سبا…) هنا.' },
        { title: 'المراجعة والتأكيد', desc: 'ملخّص نهائي للغرف والضيوف والإجمالي؛ التأكيد يُنشئ الطلب ويُصدر القسيمة.' },
      ],
    },
    related: ['hotels-search', 'hotels-ticket', 'supply-properties', 'markup'],
  },

  'hotels-ticket': {
    title: 'قسيمة الفندق',
    tag: 'القسيمة الصادرة',
    tagline: 'قسيمة الفندق المؤكدة — العقار، تواريخ الإقامة، قائمة الضيوف والرسوم.',
    business: {
      lead: 'القسيمة هي إثبات الضيف لإقامة مؤكدة والمستند الذي يعتمده الفندق عند تسجيل الوصول. تجمع العقار وخطة السعر ونظام الإعاشة وتواريخ الوصول / المغادرة ومستند كل ضيف في سجل واحد يمكن للوكالة إرساله بالبريد أو طباعته.',
      points: [
        { title: 'إثبات لتسجيل الوصول', desc: 'الرقم المرجعي بالإضافة إلى قائمة الضيوف لكل غرفة (مع المستندات) هو ما يتحقّق منه الفندق عند الوصول.' },
        { title: 'الإعاشة والاسترداد ضمن السجل', desc: 'نظام الإعاشة لخطة السعر وسياسة الإلغاء مذكوران على القسيمة، لا مدفونان في عقد.' },
        { title: 'الخدمة من هنا', desc: 'أرسل خط سير الرحلة بالبريد، انسخ الرقم المرجعي، أو عدّل / ألغِ الحجز.' },
      ],
    },
    software: {
      lead: 'قسيمة تتضمن العقار وشريط الإقامة وقائمة الضيوف لكل غرفة والرسوم.',
      points: [
        { title: 'الترويسة والعقار', desc: 'شارة «تم إصدار القسيمة» ورقم مرجعي، العقار مع علامات مؤكد / الإعاشة / الاسترداد، والبريد الإلكتروني / الطباعة / التنزيل.' },
        { title: 'شريط الإقامة', desc: 'تاريخ تسجيل الوصول (من الساعة 15:00)، عدد الليالي، وتسجيل المغادرة (بحلول الساعة 12:00).' },
        { title: 'الضيوف والرسوم', desc: 'قائمة الضيوف لكل غرفة مع المستندات، بالإضافة إلى شريط جانبي للرسوم (سعر الغرفة الأساسي، الضرائب، الإجمالي).' },
      ],
    },
    related: ['hotels-results', 'bookings', 'booking-detail'],
  },

  'tours-new': {
    title: 'منشئ باقات الجولات',
    tag: 'إنشاء الباقة',
    tagline: 'جمّع باقة متعددة الخدمات — خط السير، الرحلات الجوية، الفنادق، المشمولات والتسعير حسب الإشغال — ثم انشرها للبيع.',
    business: {
      lead: 'هذا هو جانب العرض في الجولات: حيث يبني المُشغّل المنتج الذي يبيعه الوكلاء لاحقاً. تجمع الباقة الرحلات الجوية والفنادق والتنقلات والأنشطة في وحدة SKU واحدة بخط سيرها الخاص ونافذة مغادرتها وسعرها المجمّع — لتُسوَّق بسعر رئيسي واحد ويُدار هامشها كوحدة واحدة بدلاً من الدفاع عنه بنداً بنداً.',
      points: [
        { title: 'وحدة SKU واحدة، مكوّنات كثيرة', desc: 'الرحلات الجوية والفندق مشمولة دائماً؛ التأشيرة والتنقلات والتأمين خيارات اختيارية — تُباع جميعها كسجل واحد.' },
        { title: 'مُسعّرة حسب الإشغال', desc: 'تُسعّر كل سلّة فندق عبر أدوار الإشغال (بالغ، بالغ منفرد، طفل بسرير، طفل بدون سرير، رضيع)، لتحصل الأسرة أو المسافر المنفرد على السعر الصحيح.' },
        { title: 'حالة النشر تتحكم في البيع', desc: 'تنتقل الباقة من غير نشط ← معاينة ← نشط؛ فقط المغادرات النشطة (غير الماضية) يمكن حجزها من صفحة الجولات.' },
      ],
    },
    software: {
      lead: 'معالج بخطوات من الأساسيات إلى النشر، مع التحقق من كل خطوة قبل المتابعة.',
      points: [
        { title: 'الأساسيات، خط السير، المكوّنات', desc: 'الاسم، المدن، التواريخ، الفئة والشارات؛ خطة يوماً بيوم مع مدينة المبيت لكل يوم؛ وقائمة تضمين / استبعاد من الكتالوج أو نص حر.' },
        { title: 'الرحلات الجوية وسلال الفنادق', desc: 'أرفق رحلة جوية (بحث وحجز في وضع الجولات، أو يدوياً) وابنِ سلال فنادق متعددة المدن (المدينة + الفندق + الغرفة).' },
        { title: 'التسعير والنشر', desc: 'مصفوفة أسعار لكل سلّة × لكل إشغال، ثم النشر مع أعلام التوزيع (مميّز، بريد أسبوعي، تقييد السوق، علامة بيضاء لـ B2C).' },
      ],
    },
    related: ['tours', 'flights-search', 'hotels-search', 'supply-properties'],
  },

  visa: {
    title: 'التأشيرة',
    tag: 'خدمات التأشيرات',
    tagline: 'طلبات تأشيرة قابلة للحجز مع كتالوج وأهلية ومساحة عمل للموظف خلف الكواليس.',
    business: {
      lead: 'تحوّل التأشيرة معالجة تصريح الدخول إلى خدمة قابلة للحجز. تبيع الوكالة التأشيرة بالطريقة نفسها التي تبيع بها رحلة جوية أو فندقاً — كمنتج بسعر ومدة تنفيذ وتسليم محدد — مع تدفّق موظف في المكتب الخلفي خلف الكواليس يجمع المستندات فعلياً ويقدّمها للقنصلية ويعيد القرار.',
      points: [
        { title: 'التأشيرة منتج', desc: 'لكل وجهة × نوع تأشيرة مدخل في الكتالوج مع التسعير ومدة التنفيذ والمتطلبات المستندية؛ وتُضاف علاوة الوكالة فوق ذلك.' },
        { title: 'الأهلية تحكم البيع', desc: 'جنسية المسافر والغرض من الزيارة ونافذة الصلاحية تحدد أي مدخلات الكتالوج قابلة للبيع فعلياً — البحث لا يعرض إلا التركيبات الصالحة.' },
        { title: 'يُحصّل المال وتُقدّم الخدمة', desc: 'يُؤخذ الدفع عند الحجز؛ تتابع مساحة عمل الموظف التقدم من استلام المستندات إلى إعادة القرار.' },
      ],
    },
    software: {
      lead: 'بحث في كتالوج التأشيرات بالإضافة إلى مساحة عمل موظف في المكتب الخلفي لجانب التنفيذ.',
      points: [
        { title: 'البحث في الكتالوج', desc: 'الوجهة ونوع التأشيرة وجنسية المسافر تقود النتائج؛ لا تظهر إلا التركيبات القابلة للبيع.' },
        { title: 'حجز التأشيرة', desc: 'اختيار مدخل يفتح نموذج المسافر / رفع المستندات والدفع؛ والنتيجة حجز تأشيرة.' },
        { title: 'التتبّع حتى التسليم', desc: 'تُظهر مساحة عمل الموظف كل حالة مفتوحة ومرحلتها ومستنداتها وحالتها من جانب القنصلية — يستخدمها الوكيل لتحديث العميل.' },
      ],
    },
    flow: {
      lead: 'حجز التأشيرة نصفان — البيع المواجه للعميل، ثم التنفيذ في المكتب الخلفي حتى القرار.',
      steps: [
        { title: 'تصفية الكتالوج', desc: 'بلد الوجهة، نوع التأشيرة (سياحية / تجارية / عبور / طالب) وجنسية المسافر تقود الأهلية؛ التركيبات غير المؤهلة مخفية.' },
        { title: 'قراءة المدخل', desc: 'يُظهر كل مدخل في الكتالوج الرسم ومدة التنفيذ والمتطلبات المستندية وقناة قرار القنصلية.' },
        { title: 'تسجيل المسافر', desc: 'تفاصيل المسافر (جواز السفر، تواريخ السفر، الغرض، التفاصيل الداعمة) تقود ملف الحالة.' },
        { title: 'رفع المستندات', desc: 'مسح جواز السفر، الصورة، الدعوة، الإثبات المالي — تختلف المجموعة المطلوبة لكل مدخل في الكتالوج.' },
        { title: 'الدفع وفتح الحالة', desc: 'يُحصّل الدفع عند الحجز. تُفتح الحالة في مساحة عمل الموظف عند مرحلة «تم استلام المستندات».' },
        { title: 'تنفيذ الموظف', desc: 'يراجع الموظف المستندات، يقدّمها للقنصلية، يتابع الحالة، يستلم القرار، ويُغلق الحالة بمستند تأشيرة أو رفض.' },
        { title: 'التسليم للعميل', desc: 'يُرفق مستند التأشيرة (أو شرح الرفض) بالحجز ويُتاح للوكيل لمشاركته.' },
      ],
    },
    modes: {
      lead: 'تُصنّف مدخلات التأشيرة حسب نوع التأشيرة؛ ويتكيّف التدفّق لكل نوع.',
      modes: [
        { name: 'Tourist', when: 'السفر الترفيهي', desc: 'تأشيرة زائر قياسية. رسم أقل ومدة تنفيذ أسرع في معظم الوجهات. المجموعة المستندية عادةً جواز سفر + صورة + خط سير.' },
        { name: 'Business', when: 'زيارات العمل / المؤتمرات', desc: 'تتطلب خطاب دعوة من المنظمة المضيفة. رسم أعلى، مدة تنفيذ مماثلة، وأحياناً موعد شخصي في القنصلية.' },
        { name: 'Transit', when: 'التوقّف في الوجهة', desc: 'أقصر صلاحية وأرخص رسم. صالحة فقط لنافذة العبور. ليست كل الوجهات تعرضها؛ ويرشّحها البحث تبعاً لذلك.' },
        { name: 'Student', when: 'قبول رسمي في مؤسسة محلية', desc: 'تتطلب إثبات القبول وغالباً ضماناً مالياً. أطول مدة تنفيذ؛ أعلى رسم. تتابع مساحة عمل الموظف الدورة المستندية الموسّعة.' },
      ],
    },
    examples: [
      {
        title: 'تأشيرة سياحية لتركيا · مسافر واحد · مدة تنفيذ 21 يوماً',
        rows: [
          { label: 'رسم القنصلية', value: '4,500,000' },
          { label: 'رسم الخدمة (معالجة الوكالة)', value: '1,500,000' },
          { label: 'علاوة MARKUP للتجزئة · +10% من الإجمالي', value: '+600,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '6,600,000', strong: true },
        ],
        note: 'رسم القنصلية تمريري؛ تربح الوكالة على رسم الخدمة وعلاوة التجزئة، لا على تكلفة القنصلية.',
      },
    ],
    related: ['flights-search', 'reference-data', 'markup'],
  },

  cip: {
    title: 'CIP',
    tag: 'خدمة كونسيرج المطار',
    tagline: 'خدمات الاستقبال والمساعدة وكونسيرج المطار لكبار الشخصيات تُباع إلى جانب الرحلة.',
    business: {
      lead: 'CIP (الشخص المهم تجارياً) هو كونسيرج المطار — خدمة استقبال ومساعدة تربط العميل بمنسّق مطار عند الوصول أو العبور أو المغادرة. تجارياً هي إضافة صغيرة عالية الهامش يمكن للوكالة إلحاقها بأي رحلة مؤهلة، وتُباع في الغالب لوكالات إعادة البيع بدلاً من بيعها مباشرة للمسافرين.',
      points: [
        { title: 'إيراد إضافي', desc: 'حجز الكونسيرج رخيص التنفيذ، عالي الهامش ولا ينافس بيع الرحلة/الفندق الأساسي — إيراد إضافي صافٍ.' },
        { title: 'لإعادة البيع فقط', desc: 'يُتاح كتالوج CIP للوكالات (لا للعملاء) — هذا منتج جملة يعيد الموزّع تسعيره لعميله النهائي.' },
        { title: 'مملوك لـ cip-service', desc: 'بيانات كتالوج CIP مملوكة لخدمة cip-service المخصّصة، لا لخدمة content-service، لذا يُدار التسعير والتوافر باستقلالية عن بقية بيانات المرجع.' },
      ],
    },
    software: {
      lead: 'شاشة بحث وحجز مخصّصة لكتالوج الكونسيرج مدعومة بـ cip-service.',
      points: [
        { title: 'البحث في الكتالوج', desc: 'المطار ونوع الخدمة (وصول / مغادرة / عبور) وعدد المسافرين تقود النتائج.' },
        { title: 'حجز الخدمة', desc: 'اختيار خدمة يفتح نموذج المسافر وتدفّق الدفع؛ والنتيجة حجز CIP يظهر إلى جانب كل منتج آخر في كل الحجوزات.' },
        { title: 'مُسعّر من البداية للنهاية', desc: 'يُحصّل المال عند الحجز؛ تسوية دفتر الأستاذ مع منظومة المحاسبة على خارطة طريق المرحلة الثالثة.' },
      ],
    },
    flow: {
      lead: 'حجز CIP قصير — يختار المسافر مطاراً ولحظة (وصول / مغادرة / عبور) ومستوى خدمة.',
      steps: [
        { title: 'اختيار المطار', desc: 'رمز المطار يحدد أي شبكة منسّقين متاحة؛ ليس كل مطار مغطى.' },
        { title: 'اختيار اللحظة', desc: 'الوصول أو المغادرة أو العبور — يبدأ المنسّق وينتهي عند نقاط مختلفة داخل الصالة لكل منها.' },
        { title: 'اختيار مستوى الخدمة', desc: 'استقبال ومساعدة، أو VIP، أو وصول كامل للصالة — كل مستوى يجمع امتيازات أكثر (مسار سريع، عربة، وقت في الصالة).' },
        { title: 'تحديد تفاصيل الرحلة', desc: 'رقم الرحلة وتاريخها ليتمكن المنسّق من مقابلة المسافر الصحيح.' },
        { title: 'تسجيل المسافرين + الدفع', desc: 'أسماء المسافرين + الدفع؛ يستلم المنسّق التكليف ويستلم العميل تأكيداً بنقطة اللقاء.' },
      ],
    },
    modes: {
      lead: 'يُشترى CIP في إحدى ثلاث لحظات في الرحلة، وبأحد مستويات خدمة قليلة — والكتالوج مصفوفة من ذلك.',
      modes: [
        { name: 'Arrival', when: 'رحلة قادمة', desc: 'يقابل المنسّق المسافر عند البوابة / الجسر، يتعامل مع الجوازات والأمتعة، ويرافقه إلى خارج الصالة. شائع لكبار الشخصيات والزوّار لأول مرة.' },
        { name: 'Departure', when: 'رحلة مغادرة', desc: 'يقابل المنسّق المسافر خارج الصالة، يتعامل مع تسجيل الوصول والأمن، ويرافقه إلى البوابة أو الصالة.' },
        { name: 'Transit', when: 'رحلة ربط', desc: 'يقابل المنسّق بين الرحلتين، يتعامل مع الانتقال بين الصالات والبوابات. قيّم بشكل خاص في الربط الضيق.' },
        { name: 'Meet & Assist', when: 'المستوى الأساسي', desc: 'منسّق ومساعدة جسدية — الخدمة الأساسية.' },
        { name: 'VIP', when: 'المستوى المميّز', desc: 'يضيف المسار السريع عبر الجوازات والأمن، والنقل بالعربة داخل الصالة، وأحياناً الوصول للصالة.' },
      ],
    },
    examples: [
      {
        title: 'وصول DXB · VIP · مسافران',
        rows: [
          { label: 'رسم المنسّق الأساسي (لكل مسافر) × 2', value: '2,800,000' },
          { label: 'علاوة MARKUP للجملة · +8% (وكالة المنسّق)', value: '+224,000', accent: 'info' },
          { label: 'علاوة MARKUP للتجزئة · +15% من الإجمالي', value: '+453,600', accent: 'success' },
          { label: 'إجمالي المسافر', value: '3,477,600', strong: true },
        ],
        note: 'CIP إضافة عالية الهامش — علاوة مدمجة بنسبة 20–30% أمر طبيعي هنا، مقابل 5–10% على الرحلات الجوية.',
      },
    ],
    related: ['flights-search', 'reference-data', 'markup'],
  },

  ground: {
    title: 'النقل البري',
    tag: 'الخدمات البرية',
    tagline: 'تنقلات من نقطة إلى نقطة، خدمات سائق ونقل بري لمسافات قصيرة.',
    business: {
      lead: 'يبيع النقل البري المرحلة البرية من الرحلة — تنقلات المطار، استقبالات السائق، تأجير السيارات باليوم — كمنتج قابل للحجز. إنه رفيق «الانتقال من أ إلى ب على الأرض» لبيع الرحلة الجوية أو الفندق، ويتيح للوكالة إتمام رحلة العميل بالكامل في سلّة واحدة.',
      points: [
        { title: 'يُتمّ الرحلة', desc: 'العميل الذي حجز بالفعل رحلة جوية وفندقاً مع الوكالة لديه سؤال تالٍ واضح — كيف أنتقل من أحدهما إلى الآخر. يجيب النقل البري عليه داخلياً.' },
        { title: 'يُلحق برحلة جوية', desc: 'عادةً تُشترى تنقلات المطار بعد اختيار الرحلة الجوية؛ ويمكن أن يرث وقت الاستقبال من وصول الرحلة، ما يقلّل جهد المُشغّل.' },
        { title: 'يُطبّق التسعير الطبقي', desc: 'نفس محرك Wholesale / Distribution / Retail الذي يُسعّر رحلة جوية يُسعّر أيضاً خدمة برية — والقاعدة المحدّدة النطاق للشريك تعمل هنا أيضاً.' },
      ],
    },
    software: {
      lead: 'بحث عن الاستقبال / التوصيل مع خيارات فئة المركبة وتدفّق حجز.',
      points: [
        { title: 'تكوين المرحلة', desc: 'موقع الاستقبال، موقع التوصيل، التاريخ وعدد الركاب تقود البحث؛ فئة المركبة (سيدان / دفع رباعي / فان) تضيّق الخيار.' },
        { title: 'قراءة صف المركبة', desc: 'يُظهر كل نتيجة المُشغّل، فئة المركبة، السعر والمدة المقدّرة.' },
        { title: 'المتابعة للحجز', desc: 'مركبة مختارة تفتح نموذج تفاصيل الراكب / الاستقبال والدفع؛ وينضم السجل إلى كل الحجوزات.' },
      ],
    },
    flow: {
      lead: 'حجز النقل البري قصير وغالباً ما يُلحق برحلة جوية قائمة — موقع الاستقبال، التوصيل، التوقيت، فئة المركبة.',
      steps: [
        { title: 'اختيار الاستقبال + التوصيل', desc: 'من مدينة إلى مدينة، من مطار إلى فندق، أو من نقطة إلى نقطة. يُملأ استقبال المطار مسبقاً من رحلة مطابقة في نفس PNR.' },
        { title: 'اختيار التاريخ + الوقت', desc: 'الطابع الزمني للاستقبال — لتنقلات المطار يمكن أن يرث من وصول الرحلة (معدّلاً بمهلة معيارية).' },
        { title: 'اختيار فئة المركبة', desc: 'سيدان للمنفرد / الزوجين، دفع رباعي للأسرة، فان للمجموعة. فئة المركبة تحدد السعة والأمتعة والسعر.' },
        { title: 'تسجيل الركاب + الدفع', desc: 'اسم الراكب الرئيسي وهاتفه + الدفع؛ يُرسَل السائق ويستلم المسافر تفاصيل الاستقبال.' },
      ],
    },
    modes: {
      lead: 'تنقسم الخدمات البرية حسب شكل الرحلة — تنقل لمرة واحدة أو تأجير مستمر — وحسب فئة المركبة.',
      modes: [
        { name: 'Airport transfer', when: 'رحلة قادمة / مغادرة', desc: 'استقبال لمرة واحدة من المطار إلى الفندق (أو العكس). الأرخص والأكثر شيوعاً. يرث توقيت الاستقبال من وصول الرحلة.' },
        { name: 'Point-to-point', when: 'من مدينة ← مدينة أو تنقل بين المدن', desc: 'توصيل واحد في مكان آخر في المدينة أو المنطقة. يتناسب السعر مع المسافة.' },
        { name: 'Chauffeur / hourly', when: 'اجتماعات عمل / يوم لكبار الشخصيات', desc: 'سائق + مركبة لكتلة ساعات محجوزة. يحدد المسافر مسار اليوم.' },
        { name: 'Day hire', when: 'مشاهدة المعالم على مدى يوم كامل', desc: 'مركبة + سائق ليوم كامل، عادةً بحد أقصى مسموح للكيلومترات. سعر أعلى من كتلة بالساعة.' },
      ],
    },
    examples: [
      {
        title: 'مطار DXB ← الفندق · دفع رباعي · مسافران + أمتعة',
        rows: [
          { label: 'أجرة التنقل الأساسية', value: '600,000' },
          { label: 'علاوة MARKUP للجملة · +5% (هامش المُشغّل)', value: '+30,000', accent: 'info' },
          { label: 'علاوة MARKUP للتجزئة · +10% من الإجمالي', value: '+63,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '693,000', strong: true },
        ],
        note: 'الخدمة البرية الملحقة برحلة جوية قائمة عبر PNR تشارك سجل الحجز — دفعة واحدة، قسيمة واحدة، تدفّق استرداد واحد.',
      },
    ],
    related: ['flights-search', 'buses-search', 'markup'],
  },

  sim: {
    title: 'شرائح SIM',
    tag: 'اتصال السفر',
    tagline: 'شرائح SIM / eSIM للسفر للبيانات فقط تُباع كإضافة مدفوعة لأي رحلة خارجية.',
    business: {
      lead: 'تبيع شرائح SIM خطة بيانات للوجهة إلى جانب الرحلة نفسها. يتجنب العميل رسوم التجوال، وتربح الوكالة هامشاً صغيراً، والتنفيذ (شحن شريحة فعلية، أو تسليم رمز QR لـ eSIM) رقيق بما يكفي لإبقاء تكلفة البضاعة منخفضة.',
      points: [
        { title: 'إضافة صافية', desc: 'الهامش صغير لكل وحدة لكن تكلفة الإلحاق ضئيلة؛ إنه إيراد إضافي على كل رحلة ترفيهية خارجية.' },
        { title: 'فعلية + eSIM', desc: 'الشرائح الفعلية تحتاج عنوان تسليم ومدة تنفيذ؛ شرائح eSIM تُسلَّم كرمز QR فوراً عند الحجز، ما يغيّر التدفّق.' },
        { title: 'محدّدة حسب الوجهة', desc: 'كل خطة مربوطة ببلد أو منطقة وحدّ بيانات / نافذة صلاحية — والكتالوج مصفوفة من تلك التركيبات.' },
      ],
    },
    software: {
      lead: 'بحث عن الوجهة + الخطة مدعوم بكتالوج SIM.',
      points: [
        { title: 'البحث في الكتالوج', desc: 'بلد الوجهة ونافذة الصلاحية تقود النتائج؛ وحدّ البيانات يضيّق أكثر.' },
        { title: 'قراءة صف الخطة', desc: 'يُظهر كل صف المُشغّل، حدّ البيانات، الصلاحية والسعر؛ ونوع الشريحة (فعلية مقابل eSIM) يؤثر في التنفيذ.' },
        { title: 'حجز الخطة', desc: 'اختيار خطة يفتح نموذج تفاصيل المسافر / التسليم والدفع؛ سجلات eSIM تُسلَّم فوراً، والشرائح الفعلية تجدول تسليماً.' },
      ],
    },
    flow: {
      lead: 'حجز SIM من أقصر تدفّقات المخزون — الوجهة، الحدّ، نوع الشريحة، التسليم.',
      steps: [
        { title: 'اختيار الوجهة', desc: 'بلد أو منطقة — يُفهرس الكتالوج حسب منطقة التغطية، لا حسب المُشغّل.' },
        { title: 'اختيار نافذة الصلاحية', desc: 'مدة الرحلة تحدد أي خطط تنطبق — خطة 7 أيام لن تناسب رحلة 21 يوماً.' },
        { title: 'اختيار الحدّ', desc: 'ميزانية البيانات (غير محدودة / 10GB / 20GB) تضيّق أكثر؛ الخطط غير المحدودة عادةً تخنق السرعة بعد حدّ الاستخدام العادل.' },
        { title: 'اختيار نوع الشريحة', desc: 'شريحة فعلية (تحتاج عنوان تسليم + مدة تنفيذ) أو eSIM (رمز QR يُسلَّم عند الحجز). توافق هاتف المسافر يحدد الاختيار.' },
        { title: 'التسجيل + الدفع', desc: 'المسافر + عنوان التسليم (للفعلية فقط) + الدفع. رمز QR لـ eSIM يظهر فوراً على التأكيد؛ وشحن الشريحة الفعلية يُجدول.' },
      ],
    },
    modes: {
      lead: 'يهمّ بُعدان — التنفيذ الفعلي مقابل eSIM، والتغطية الجغرافية.',
      modes: [
        { name: 'Physical SIM', when: 'هاتف المسافر لا يدعم eSIM', desc: 'شريحة نانو / مايكرو تُشحن إلى عنوان المسافر (أو تُستلم من مكتب شريك). تحتاج مدة تنفيذ 3–5 أيام في معظم المسارات، لذا احجز مبكراً.' },
        { name: 'eSIM', when: 'هاتف المسافر يدعم eSIM (معظم الهواتف الذكية الحديثة)', desc: 'رمز QR يُسلَّم عند الحجز — لا شحن، لا مدة تنفيذ. يمسحه المسافر عند الوصول فيُفعَّل الملف. تكلفة بضاعة صفرية على الوكالة.' },
        { name: 'Country-specific', when: 'رحلة إلى وجهة واحدة', desc: 'الخطة صالحة في بلد واحد. أرخص سعر لكل GB.' },
        { name: 'Regional', when: 'رحلة متعددة البلدان (مثلاً تنقل في أوروبا)', desc: 'الخطة صالحة عبر منطقة محددة (كل الاتحاد الأوروبي، آسيا والمحيط الهادئ، دول الخليج). سعر أعلى لكل GB لكن دون الحاجة لتبديل الشرائح عند كل حدود.' },
        { name: 'Global', when: 'رحلة طويلة متعددة المناطق', desc: 'الخطة صالحة في قائمة بلدان واسعة — أكثر من 100 بلد. أعلى سعر لكل GB؛ تناسب المسافرين حول العالم أو رجال الأعمال.' },
      ],
    },
    examples: [
      {
        title: 'تركيا · 10 أيام 10GB · eSIM · مسافر واحد',
        rows: [
          { label: 'تكلفة خطة المورّد', value: '600,000' },
          { label: 'علاوة MARKUP للتجزئة · +30% (إضافة عالية الهامش)', value: '+180,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '780,000', strong: true },
        ],
        note: 'eSIM بتكلفة تنفيذ صفرية — يولّد المورّد رمز QR ويُسلَّم عند التأكيد، لذا تتحوّل العلاوة كلها إلى هامش.',
      },
      {
        title: 'نفس الرحلة · شريحة فعلية',
        rows: [
          { label: 'تكلفة خطة المورّد', value: '600,000' },
          { label: 'الشحن', value: '100,000' },
          { label: 'علاوة MARKUP للتجزئة · +25% من الإجمالي', value: '+175,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '875,000', strong: true },
        ],
        note: 'الشرائح الفعلية تضيف تكلفة الشحن ومدة تنفيذ الشحن — نسخة eSIM عموماً هي البيع الأفضل حين يدعمها هاتف العميل.',
      },
    ],
    related: ['visa', 'insurance', 'flights-search'],
  },

  insurance: {
    title: 'تأمين السفر',
    tag: 'حماية الرحلة',
    tagline: 'وثائق تأمين سفر قابلة للحجز تُباع كإضافة للرحلة.',
    business: {
      lead: 'يحمي تأمين السفر العميل من اضطرابات الرحلة (التأخيرات، الإلغاءات، الطبية، الأمتعة) ويمنح الوكالة خط إيراد إضافي. تتطلب بعض الوجهات تغطية سارية كشرط للتأشيرة، لذا قد يكون أيضاً منتج امتثال لا مجرد خيار صرف.',
      points: [
        { title: 'الاختياري والإلزامي موجودان معاً', desc: 'لبعض التأشيرات تُشترط التغطية للتأهل؛ ولرحلات الترفيه الصرفة هو خيار يبيعه الوكيل بالترقية عند الإتمام.' },
        { title: 'خطط متدرجة', desc: 'تُعرَّف الخطة بحدود تغطيتها ومدتها — يختار العميل مستوى يطابق تحمّله للمخاطر وميزانيته.' },
        { title: 'مكتتَب خارجياً', desc: 'لا تكتتب المنصة الوثيقة — تبيع منتج طرف ثالث وتحجز سجل الوثيقة الناتج على رحلة العميل.' },
      ],
    },
    software: {
      lead: 'بحث عن المسافر + الوجهة عبر كتالوج التأمين المتصل.',
      points: [
        { title: 'تكوين التغطية', desc: 'الوجهة وتواريخ السفر وأعمار المسافرين تقود النتائج؛ ومستوى التغطية يضيّق الخطة.' },
        { title: 'قراءة صف الخطة', desc: 'يُظهر كل نتيجة المكتتِب وحدود التغطية والسعر؛ وتُفتح مستندات الوثيقة عند الاختيار.' },
        { title: 'حجز الوثيقة', desc: 'اختيار خطة يفتح نموذج المسافر والدفع؛ ويُرفق سجل الوثيقة ومستنداتها برحلة العميل.' },
      ],
    },
    flow: {
      lead: 'حجز الوثيقة قصير — الوجهة، تواريخ السفر، أعمار المسافرين، المستوى، الدفع.',
      steps: [
        { title: 'اختيار شكل الرحلة', desc: 'بلد / منطقة الوجهة، تواريخ السفر، وعمر كل مسافر (يتناسب السعر مع الفئة العمرية).' },
        { title: 'اختيار مستوى التغطية', desc: 'الأساسي يغطي الضروريات فقط؛ القياسي يضيف الأمتعة / التأخير؛ المميّز يضيف الطبي الكامل + إلغاء الرحلة. اختر بما يطابق قيمة الرحلة المعرّضة للخطر.' },
        { title: 'قراءة الخطة', desc: 'تدرج كل خطة حدود التغطية لكل بند (طبي، إلغاء، أمتعة) والاستثناءات. تُفتح مستندات الوثيقة على الشاشة نفسها.' },
        { title: 'تسجيل المسافرين + الدفع', desc: 'أسماء المسافرين وتواريخ ميلادهم وأرقام جوازاتهم + الدفع؛ وتُصدر الوثيقة عند الحجز.' },
        { title: 'الحصول على مستندات الوثيقة', desc: 'ملف PDF للوثيقة + الشهادة يُرفقان بالحجز. بعض الوجهات تتطلب الشهادة عند التقديم للقنصلية.' },
      ],
    },
    modes: {
      lead: 'يُسعّر التأمين بمحورين — مستوى التغطية (ما يُغطّى) وشكل الرحلة (رحلة واحدة مقابل سنوية).',
      modes: [
        { name: 'Basic tier', when: 'رحلات محلية / ترفيهية قصيرة', desc: 'الطوارئ الطبية + الإعادة إلى الوطن. الأمتعة والإلغاء غير مشمولة. أرخص قسط.' },
        { name: 'Standard tier', when: 'معظم السفر الترفيهي', desc: 'يضيف فقدان الأمتعة، تأخير الرحلة، والإلغاء المحدود. المستوى الأكثر بيعاً.' },
        { name: 'Premium tier', when: 'الرحلات باهظة الثمن أو المسافرون الأكبر سناً', desc: 'يضيف الطبي الكامل (حدود أعلى)، الإلغاء الكامل لأي سبب، الأنشطة المغامرة. أعلى قسط.' },
        { name: 'Single-trip', when: 'رحلة واحدة في الأسابيع القادمة', desc: 'يغطي نافذة تاريخ محددة (بداية ← نهاية الرحلة). الأرخص للمسافرين العرضيين.' },
        { name: 'Annual multi-trip', when: 'السفر التجاري أو الترفيهي المتكرر', desc: 'يغطي كل رحلة خلال سنة، حتى حد أقصى لطول الرحلة الواحدة (عادةً 30–60 يوماً). أرخص عند 3 رحلات أو أكثر سنوياً من شراء رحلة واحدة في كل مرة.' },
      ],
    },
    examples: [
      {
        title: 'تركيا · رحلة 10 أيام · المستوى القياسي · بالغان + طفل',
        rows: [
          { label: 'القسط الأساسي (بالغ) × 2', value: '1,400,000' },
          { label: 'القسط الأساسي (طفل)', value: '400,000' },
          { label: 'المجموع الفرعي', value: '1,800,000' },
          { label: 'علاوة MARKUP للتجزئة · +20% عمولة', value: '+360,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '2,160,000', strong: true },
        ],
        note: 'عمولات التأمين عادةً 15–25% من القسط — هامش إضافي متين لكل حجز، ووثيقة واحدة تغطي الجميع في الرحلة.',
      },
    ],
    related: ['visa', 'sim', 'flights-search'],
  },

  bookings: {
    title: 'كل الحجوزات',
    tag: 'دفتر الطلبات',
    tagline: 'كل طلب أجرته الوكالة، عبر كل منتج، في قائمة واحدة.',
    business: {
      lead: 'كل الحجوزات هي السجل التشغيلي لكل ما بيع — رحلات جوية، فنادق، جولات، نقل، تأشيرات، CIP — كطلبات موحّدة. إنها المكان الذي يجد فيه الموظفون حجز العميل لخدمته: إعادة الإصدار، إضافة إضافات، الإلغاء، الاسترداد أو ببساطة التحقق من موقفه.',
      points: [
        { title: 'طلب واحد، منتجات كثيرة', desc: 'يمكن لطلب واحد أن يجمع رحلة جوية وفندقاً وإضافة — كل منها بند تحت نفس الرقم المرجعي / PNR.' },
        { title: 'الحالة تخبرك بما يجب فعله', desc: 'مسودّة ← محتجز ← مؤكد ← مدفوع، بالإضافة إلى قيد المراجعة (إقامة عند الطلب تنتظر التأكيد) وملغى — الشارة تُظهر موقف الحجز.' },
        { title: 'سطح الخدمة', desc: 'كل إجراء بعد البيع (إلغاء، استرداد، رسوم، مستندات) يبدأ بإيجاد الطلب هنا.' },
      ],
    },
    software: {
      lead: 'جدول طلبات قابل للبحث والتصفية — وهدف بحث الشريط العلوي العام.',
      points: [
        { title: 'إيجاد سريع', desc: 'ابحث بالرقم المرجعي أو PNR أو المسافر أو جهة الاتصال؛ صفّ حسب المنتج أو الحالة أو التاريخ.' },
        { title: 'البحث العام ينتهي هنا', desc: 'بحث في الشريط العلوي ليس نتيجة فريدة يدرج مطابقاته هنا؛ والنتيجة الفريدة تقفز مباشرة إلى تفاصيل الحجز.' },
        { title: 'الفتح للخدمة', desc: 'انقر على صف لفتح تفاصيل الحجز الكاملة والعمل عليها.' },
      ],
    },
    related: ['booking-detail', 'queue', 'refunds', 'counter'],
  },

  'booking-detail': {
    title: 'تفاصيل الحجز',
    tag: 'سجل الطلب',
    tagline: 'السجل الكامل بخمس طبقات لطلب واحد — البنود، المال، المدفوعات، المستندات والإجراءات.',
    business: {
      lead: 'يُنمذج الحجز بخمس طبقات — الطلب ← البند ← مرجع المورّد ← المستند ← القسيمة — لتُنسب كل أجرة وضريبة ورسم واسترداد بدقة للشيء الذي تخصّه. هذه الشاشة هي حيث يُفهم الطلب الواحد ويُخدَم من البداية للنهاية.',
      points: [
        { title: 'خمس طبقات، إسناد دقيق', desc: 'يتجمّع المال من القسائم والمستندات إلى البنود ثم الطلب، لتعرف دائماً من يدين بماذا.' },
        { title: 'الإلغاء على كل مستوى', desc: 'ألغِ قسيمة واحدة، مستنداً، بنداً، أو الطلب كله — دائماً مع عرض سعر قبل أن يتحرك أي مال.' },
        { title: 'عند الطلب يعيش هنا', desc: 'طلب فندق معلّق (قيد المراجعة) يُظهر شريط تأكيد / رفض — التأكيد يحصّل الدفع المُصرّح به، والرفض يُبطله.' },
      ],
    },
    software: {
      lead: 'سجل بعلامات تبويب مع بيانات مالية لكل مستوى وإجراءات ما بعد البيع.',
      points: [
        { title: 'البنود', desc: 'التفصيل بالبنود — كل منتج كبند مع مقاطعه / غرفه، الركاب والحالة.' },
        { title: 'البيانات المالية', desc: 'مصفوفة المال: الصافي، العلاوات، الضرائب، الرسوم، الخصومات، العمولات والهامش عند كل مستوى.' },
        { title: 'المدفوعات', desc: 'مراحل الدفع (مُصرّح / محصّل / مسترد / مبطَل) والرصيد المستحق.' },
        { title: 'المستندات', desc: 'مستندات المورّد الصادرة؛ تذكرة الطيران الإلكترونية تفتح قسيمة تذكرة الطيران ثنائية اللغة الجاهزة للطباعة، ويمكن إرفاق مسوحات الوكالة.' },
        { title: 'الرسوم', desc: 'رسوم ما بعد الحجز — أضف رسوماً أو خدمات إضافية أو غرامات أو خصومات، وتعديلات هيكلية (إضافة مسافر / بند، تصحيح اسم) مع VAT.' },
        { title: 'التذاكر', desc: 'تذاكر الدعم المرفوعة على بنود هذا الحجز بين الوكالة ومكتب المنصة.' },
        { title: 'الإلغاء والاسترداد', desc: 'اعرض ونفّذ إلغاءً على أي مستوى؛ وتُوجَّه الاستردادات إلى سير عمل موافقة الاستردادات والإبطالات.' },
      ],
    },
    examples: [
      {
        title: 'كيف يتجمّع المال (بند فندق واحد)',
        rows: [
          { label: 'صافي المورّد', value: '7,400,000' },
          { label: '+ علاوة التجزئة', value: '+1,110,000', accent: 'info' },
          { label: '+ الخدمات الإضافية و VAT', value: '+990,000', accent: 'success' },
          { label: 'إجمالي البيع', value: '9,500,000', strong: true, accent: 'accent' },
          { label: '− المدفوع', value: '9,500,000' },
          { label: 'الرصيد المستحق', value: '0', strong: true },
        ],
        note: 'إجمالي الطلب هو مجموع بنوده؛ وإجمالي بيع كل بند هو صافيه بالإضافة إلى طبقات العلاوة والرسوم والضرائب المنسوبة إليه.',
      },
    ],
    related: ['bookings', 'refunds', 'queue'],
  },

  queue: {
    title: 'قائمة انتظار الحجوزات',
    tag: 'احتجازات PNR',
    tagline: 'رموز PNR تحتجز مخزوناً ولا تزال تحتاج إصدار تذكرة أو إجراء مورّد.',
    business: {
      lead: 'يحجز PNR المحتجز مخزوناً لكن لم تُصدر له تذكرة بعد — إنه وعد بموعد نهائي. تُظهر قائمة الانتظار هذه ليتصرف الموظفون قبل انتهاء الاحتجاز وإعادة المقعد أو الغرفة تلقائياً إلى المورّد.',
      points: [
        { title: 'الاحتجازات قابلة للتلف', desc: 'رموز PNR غير المصدَّرة تُلغى تلقائياً عند انقضاء نافذة احتجازها (يعمل ماسح كل 60 ثانية)، ما يحرّر المخزون.' },
        { title: 'سابق الساعة', desc: 'الوقت حتى إصدار التذكرة هو المقياس المهم — أصدر في الوقت المناسب وإلا فُقد الحجز.' },
        { title: 'ليس إصدار التذاكر فقط', desc: 'بعض الصفوف تنتظر مورّداً (مثلاً تأكيد عند الطلب)، لا مجرد إجراء إصدارك.' },
      ],
    },
    software: {
      lead: 'قائمة عمل مرتّبة زمنياً للاحتجازات مع مواعيدها النهائية.',
      points: [
        { title: 'اطّلع على ما ينتهي', desc: 'يُظهر كل صف انتهاء احتجازه، لتطفو الأكثر إلحاحاً إلى الأعلى.' },
        { title: 'التصرف على صف', desc: 'افتح الحجز لإصدار / إصدار تذكرة أو اتخاذ إجراء المورّد المطلوب.' },
        { title: 'الإلغاء التلقائي تلقائي', desc: 'الاحتجازات المنتهية يحرّرها الماسح الخلفي وتسقط من قائمة الانتظار.' },
      ],
    },
    related: ['bookings', 'booking-detail'],
  },

  refunds: {
    title: 'الاستردادات والإبطالات',
    tag: 'مال ما بعد البيع',
    tagline: 'سير العمل المُتحكَّم به لإعادة المال — الإلغاءات والاستردادات والإبطالات.',
    business: {
      lead: 'عند إلغاء حجز يجب أن يعود المال بشكل صحيح وتحت السيطرة. الاستردادات والإبطالات هي حيث تُرفع الطلبات وتُوافَق، لتتبع الاستردادات قواعد الأجرة ولا يخرج شيء دون تدقيق.',
      points: [
        { title: 'البدء مقابل الموافقة', desc: 'رفع الاسترداد والموافقة عليه خطوتان منفصلتان — الموافقة هي بوابة تحريك المال، محتجزة خلف صلاحيتها الخاصة.' },
        { title: 'الإبطال مقابل الاسترداد', desc: 'الإبطال يلغي تصريحاً لم يُحصَّل قط (لم يُخصَم شيء)؛ والاسترداد يعيد المال المحصّل، ناقص أي غرامة.' },
        { title: 'قواعد، لا تخمين', desc: 'تتبع المبالغ قواعد الأجرة / الإلغاء وأي غرامة؛ ويسجّل الطلب التفصيل.' },
      ],
    },
    software: {
      lead: 'قائمة انتظار طلبات الاسترداد / الإبطال مع حالتها ومبالغها.',
      points: [
        { title: 'العمل على القائمة', desc: 'اطّلع على الطلبات المعلّقة مع مبلغها وغرامتها وسببها.' },
        { title: 'الموافقة أو الرفض', desc: 'وافق لتحريك المال (استرداد المحصّل / إبطال التصريح) أو ارفض مع سبب.' },
        { title: 'قابل للتتبّع', desc: 'كل قرار يُنسَب ويُربط بالحجز الأصلي.' },
      ],
    },
    related: ['booking-detail', 'bookings'],
  },

  counter: {
    title: 'الكاونتر',
    tag: 'النقد و POS',
    tagline: 'مناوبات أمين الصندوق، حركات النقد و POS، وتسوية نهاية اليوم.',
    business: {
      lead: 'للوكالات التي تبيع عبر كاونتر فعلي، هذه هي طبقة التحكم في النقد: تتابع من في المناوبة، كل حركة نقد وبطاقة، وتسوّي الصندوق في نهاية اليوم لتطابق المتحصّلات السجل.',
      points: [
        { title: 'المساءلة لكل مناوبة', desc: 'فتح المناوبة وإغلاقها يربط كل حركة بأمين صندوق وجلسة.' },
        { title: 'انضباط النقد', desc: 'تسجيل حركات النقد و POS فور حدوثها هو ما يجعل تسوية نهاية اليوم ممكنة.' },
        { title: 'سوِّ، لا تخمّن', desc: 'إغلاق نهاية اليوم يقارن المتوقّع بالمعدود، لتظهر أي اختلاف فوراً.' },
      ],
    },
    software: {
      lead: 'لوحة معلومات للمناوبة الحالية مع حركاتها وتسويتها.',
      points: [
        { title: 'فتح / إغلاق مناوبة', desc: 'ابدأ جلسة لبدء التسجيل؛ أغلقها للتسوية.' },
        { title: 'تسجيل الحركات', desc: 'سجّل النقد الداخل / الخارج ومعاملات POS خلال المناوبة.' },
        { title: 'التسوية عند الإغلاق', desc: 'قارن المتوقّع بالمعدود وسجّل الفرق.' },
      ],
    },
    related: ['bookings', 'refunds'],
  },
};
